// extracted by mini-css-extract-plugin
export default {"withBreadcrumb":"PageHeader_withBreadcrumb__6SJhg","titleSection":"PageHeader_titleSection__yVK20","content":"PageHeader_content__dMLgk","subtitle":"PageHeader_subtitle__xA-f7"};